/**
 * Client push-registration constants: Android channel, storage keys, and the
 * soft pre-prompt copy shown before the OS permission dialog.
 */

/** Android notification channel id — must match the `channelId` the server sends. */
export const PUSH_ANDROID_CHANNEL_ID = 'default'
export const PUSH_ANDROID_CHANNEL_NAME = 'Default'

/** AsyncStorage key: the last token+timezone we POSTed (skip redundant re-POSTs). */
export const PUSH_LAST_SENT_STORAGE_KEY = 'push_last_sent_v1'

/** Per-user AsyncStorage key prefix: whether we've already shown the permission prime. */
export const pushPrimedStorageKey = (userId: string): string => `push_permission_primed_${userId}`

/** Soft pre-prompt shown before the OS dialog (one shot, after the first pick). */
export const PUSH_PRIME_DIALOG = {
  TITLE: 'Get notified',
  MESSAGE:
    'Turn on notifications so you know the moment your picks are settled, a friend challenges you, or the clock is ticking.',
  CONFIRM_TEXT: 'Enable',
  CANCEL_TEXT: 'Not now',
} as const
